/** String používaný jako prefix při ukládání dat objednávky do localStorage. */
export const ORDER_STORAGE_PREFIX = "orderProcess";

/** String používaný jako klíč pro local storage pro uložení aktivní společnosti uživatele. */
export const SPOLECNOST_ID_KEY = "spolecnostId";

/** String používaný jako klíč pro local storage pro uložení času rozpracování objednávky. */
export const CAS_ROZPRACOVANI_KEY = "orderStartTime";

/** Implicitní nejnižší a nejvyšší čas pro výběr časového rozmezí, pokud není u firmy nastaven. **/
export const LOWEST_TIME = new Date(1900, 0, 1, 0, 0, 0);
export const HIGHEST_TIME = new Date(1900, 0, 1, 23, 59, 59);

/** Implicitní velikost kroku při výběru času, pokud není u firmy nastaven. **/
export const TIME_STEP = 30;
